export const VocabAppointments = {
    'add_appointment' : ['Añadir cita', 'Add appointment'],
    'cancel_appointment': ['Cancelar cita', 'Cancel appointment'],
    'cancel_appointment_message': ['¿Estás seguro de que quieres cancelar la cita?', 'Are you sure you want to cancel the appointment'],
    
    'patient_type': ['Tipo de paciente', 'Patient type'],

    'network_patient': ['En la red', 'In network'],
    'external_patient': ['Externo', 'External'],

    'network_username': ['Nombre de usuario', 'Username'],
    'network_search_placeholder': ['Ej: Usuario123', 'Ex: User123'],

    'external_patient_name': ['Nombre de externo', 'External name'],
    'external_patient_name_placeholder': ['Nombre completo', 'Full name'],
    'external_phone_number': ['Numero telefonico', 'Phone number'],
    'external_phone_number_placeholder': ['Escriba numero de contacto', 'Type in contact number'],
    
    'patient': ['Paciente', 'Patient'],

    'patient_placeholder': ['Introduce nombre de usuario del paciente', 'Enter patient username'],

    'title' : ['Título', 'Title'],
    'title_default' : ['Cita', 'Appointment'],
    'title_placeholder' : ['Indroduce título', 'Enter event title'],

    'description': ['Descripción', 'Description'],
    'description_placeholder': ['Indroduce una descripción', 'Type a description'],

    'start_time': ['Inicio', 'Start'],
    'end_time': ['Fin', 'End'],

    'location': ['Ubicación', 'Location'],
    'location_placeholder': ['Indroduce una ubicación', 'Enter a location'],
  }
  
  export const buttonTextMap = {
        // Spanish lan=0
    0: {
        today: 'Hoy',
        month: 'Mes',
        week: 'Semana',
        day: 'Día'
    },
    // English lan=1
    1: {
        today: 'Today',
        month: 'Month',
        week: 'Week',
        day: 'Day'
    },
};